import Devices from '@/resources/devices';
import normalize from '@/lib/normalize';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'device';
const DEFAULT_STATE = {
  data: null
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },

  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    parseResponseData(state, response) {
      state.data = normalize(response, {
        agent: {
          substation: { project: true }
        },
        'tdr-registers-index': true,
        'rc-impedance-data': true
      });
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    fetchData({ commit }, options) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      Devices.get(options).then(
        response => {
          commit('parseResponseData', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => RootStateCommit(commit, 'setResponseError', MODULE_NAME)
      );
    }
  }
};
